import { createFileRoute } from '@tanstack/react-router';
import { requireSession } from '../../../auth/require-session.js';
import { SessionError, SessionPending } from '../../../auth/SessionStates.js';
import { ReadPage } from '../../../read/read-page.js';

/** `/read/:id` (1.W deliverable 5): Read mode, guarded as `/doc/:id` is. */
export const Route = createFileRoute('/read/$id/')({
  staticData: { crumb: 'Read' },
  beforeLoad: async ({ location }) => ({ me: await requireSession(location.pathname) }),
  pendingComponent: SessionPending,
  pendingMs: 0,
  pendingMinMs: 0,
  errorComponent: SessionError,
  component: ReadRoute,
});

function ReadRoute(): React.JSX.Element {
  const { id } = Route.useParams();
  return <ReadPage key={id} docId={id} />;
}
